import React from 'react';
import background from '../../assets/coral.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoCoral extends React.Component {
  render () {
    return(


    <ReusableInfoCard     

    tag="OCEANS"
    subtag="ENDANGERED"
    description="Coral Reefs"
        
    paragraph="Coral ecosystems provide food, protect coastlines from storms, and make up vital spawning and nursery grounds for economically important fish species. Reefs also help regulate climate by taking in atmospheric CO2."
    
    background= {background}
    />
  
  );
 }
}
export default InfoCoral;